<template>
  <div class="h-[100vh] absolute w-full flex justify-center items-center">
  </div>
  <full-screen-section v-slot="{ cardClass, cardRounded }" bg="login"
    class="h-[100vh] fixed w-full flex justify-evenly bg-[url('../../assets/img/bg4.png')] bg-black bg-cover bg-right-center">
    <card-component
      class="z-10 bg-white/[0.5] dark:bg-slate-900/[0.85] backdrop-blur-[10px] dark:backdrop-blur-[3px] border-solid border-white border-opacity-20 "
      :class="cardClass" :rounded="cardRounded" form @submit.prevent="submit">
      <base-Notification v-if="storeVar.msg" :color="storeVar.status ? 'success' : 'danger'">{{ storeVar.msg
      }}</base-Notification>
      <div class="flex justify-center font-extrabold text-xl">Login as User</div>
      <base-divider />
      <!-- <base-field label="Email Id" :help="formVar.submit? userId:''">
        <base-control v-model="formVar.userId" name="login" placeholder="Enter Email Id" @keydown="disableTab($event)" @paste="disablePaste" @copy="disableCopy" autocomplete="off" />
      </base-field> -->
      <base-field label="Username" :help="formVar.submit ? userId : ''">
        <base-control v-model="formVar.userId" name="login" placeholder="Enter Username" autocomplete="login" />
      </base-field>
      <base-field label="Phone" :help="formVar.submit ? phoneValid : ''">
        <base-control v-model="formVar.phoneNumber" name="phone" v-on:keypress="isNumber($event)"
          v-on:keyup="phnum($event.target.value)" placeholder="Enter Phone Number" autocomplete="phone" />
      </base-field>
      <base-field label="Password" :help="formVar.submit ? userPassword : ''">
        <base-control v-model="formVar.userPassword" placeholder="Enter Password" type="password" autocomplete="off" />
      </base-field>
      <base-field v-if="storeVar.otpStatus" label="OTP " :help="formVar.submit ? otpValid : ''">
        <base-control v-model="formVar.otp" placeholder="Enter OTP" type="text" autocomplete="off" />
      </base-field>
      <div class="flex justify-end" v-if="storeVar.otpStatus">
        <span class="select-none cursor-pointer" @click="resendOtp">Resend OTP</span>
      </div>
      <base-divider />

      <base-buttons class="flex justify-center">
        <base-button type="submit" color="info" label="Login" />
      </base-buttons>
    </card-component>
  </full-screen-section>
</template>

<script setup>
import { computed, reactive } from 'vue'
import { useStore } from 'vuex'
const store = useStore()

const formVar = reactive({
  submit: false,
  userId: null,
  userPassword: null,
  phoneNumber: null,
  otp: null
})

const storeVar = computed(() => store.state.Auth)

// validation message
const userId = computed(() => {
  if (!formVar.userId) {
    return 'Please enter username'
  } else {
    return null
  }
})

const userPassword = computed(() => {
  if (!formVar.userPassword) {
    return 'Please enter password'
  } else {
    return null
  }
})
const otpValid = computed(() => {
  if (!formVar.otp) {
    return 'Please enter OTP'
  } else {
    return null
  }
})
const phoneValid = computed(() => {
  let phoneValid = /^[6-9][0-9]{9}$/
  if (!formVar.phoneNumber) {
    return "Please enter your phone no!";
  } else if (!phoneValid.test(formVar.phoneNumber)) {
    return "Please enter valid phone no!";
  } else {
    return null
  }
});
// end validation message

const submit = () => {
  if (userId.value ||
    userPassword.value) {
    formVar.submit = true
    return;
  }
  if (!storeVar.value.otpStatus) {
    formVar.submit = false
    store.dispatch('Auth/verifyUser', {
      loginId: formVar.userId,
      phoneNumber: formVar.phoneNumber,
      password: formVar.userPassword
    })


  } else if (storeVar.value.otpStatus) {
    if (otpValid.value) {
      formVar.submit = true
      return;
    }
    formVar.submit = false
    store.dispatch('Auth/verifyOtp', {
      phoneNumber: formVar.phoneNumber,
      otp: formVar.otp
    })
  }
}

function resendOtp() {
  if (userId.value ||
    userPassword.value) {
    formVar.submit = true
    return;
  }
  formVar.submit = false
  store.dispatch('Auth/verifyUser', {
    loginId: formVar.userId,
    phoneNumber: formVar.phoneNumber,
    password: formVar.userPassword
  })
}



function isNumber(e) {
  let char = String.fromCharCode(e.keyCode);
  if (/^[0-9]+$/.test(char)) return true;
  else e.preventDefault();
}
function phnum(e) {
  formVar.phoneNumber = e.slice(0, 10)
}
</script>
